import { useEffect, useRef } from 'react'
import { CustomAction } from '@weblite-wapps/protocol'
import { useSelector } from '../setup/redux'
import { wappView } from '../wapprunner-pool/wapprunnerPool.reducer'
import { BookmarkData, WappStage } from '../common'

/**
 * Will be called once and before component render phase
 *
 * Note: useRef will be instantiate once
 * 1. don't replace it with createRef
 * 2. don't expect same behaviour if you cause component re-render from higher scope
 *    e.g. with key attribute or parent render
 * 3. don't use useEffect cause it will be called after component render
 *
 * @param {Function} func
 */
export const useComponentWillMount = (func: () => unknown) => {
  const willMount = useRef(true)
  if (willMount.current) func()
  willMount.current = false
}

/**
 * Will be called once and before component is totally removed from the DOM
 *
 * @param {Function} func
 */
export const useComponentWillUnMount = (func: () => unknown) => {
  useEffect(() => {
    return () => {
      func()
    }
  }, [])
}

export function useWappStage(wappSessionId: string): WappStage {
  const wapp = useSelector(() => wappView(wappSessionId))
  return wapp?.stage
}

export function useWappCustomActions(wappSessionId: string): CustomAction[] {
  const wapp = useSelector(() => wappView(wappSessionId))
  return wapp?.customActions || []
}

export function useWappBookmarkData(wappSessionId: string): BookmarkData {
  const wapp = useSelector(() => wappView(wappSessionId))
  return wapp?.bookmarkData
}
